import { t } from "@lingui/macro"
import { observer } from "mobx-react"
import { useCallback } from "react"

import { EmbeddedIntegrationStore } from "src/modals/embedded-integration-v2/store"

import { FormFieldSet } from "src/components/FormFieldSet"
import { SegmentPickerField } from "src/components/SegmentPickerField"
import { useStore } from "src/store/lib/useStore"

export const EmbeddedIntegrationPublishSettingsSection = observer(() => {
    const store = useStore(EmbeddedIntegrationStore)

    const handleSegmentsChange = useCallback(
        (segments: number[]) => {
            store.fields.set("segmentIds", segments)
        },
        [store.fields],
    )

    const handlePublishGroupChange = useCallback(
        (publishGroupIds: number[]) => {
            store.fields.set("dimensionIds", publishGroupIds)
        },
        [store.fields],
    )

    return (
        <>
            <FormFieldSet
                header={t`embed-integrations-modal.publish-settings-section.receivers-header`}
            >
                <SegmentPickerField
                    value={store.fields.get("segmentIds")}
                    accessGroupId={store.accessGroupId}
                    onChange={handleSegmentsChange}
                    dimensionIds={store.fields.get("dimensionIds")}
                    onPublishGroupChange={handlePublishGroupChange}
                />
            </FormFieldSet>
        </>
    )
})
